import 'styles/index.scss'

import classNames from 'classnames'
import Banner from 'components/Banner'
import Header from 'components/Header'
import style from 'components/Layout.module.scss'
import Navigation from 'components/Navigation'
import Footer from 'components/shared/footer'
import { AnimatePresence, motion } from 'framer-motion'
import { useStores } from 'hooks/useStores'
import { transitionDefaults } from 'lib/constants'
import { observer } from 'mobx-react'
import PropTypes from 'prop-types'
import React, { useState } from 'react'
import { Helmet } from 'react-helmet'

const Layout = ({ children, navigation, banner, allResources }) => {
  const { uiStore } = useStores()

  const handleBannerDismiss = () => {
    uiStore.setShowBanner(false)
  }

  const bannerHeight = uiStore.isSmallerThanTablet ? 65 : 45

  const className = classNames(style.root, {
    [style.root___hasBanner]: !!banner,
  })

  return (
    <div className={className}>
      <Helmet>
        <link rel="dns-prefetch" href="//www.google-analytics.com" />
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1, shrink-to-fit=no"
        />
        <meta charSet="utf-8" />
        <meta name="apple-mobile-web-app-status-bar-style" content="black" />
        <meta name="apple-mobile-web-app-title" content="Teaching Center" />
      </Helmet>

      <AnimatePresence>
        {uiStore.showBanner && (
          <motion.div
            className={style.banner}
            animate={{ y: 0 }}
            exit={{ y: '-100%' }}
            transition={{ ...transitionDefaults, duration: 0.75 }}
          >
            <Banner banner={banner} onDismiss={handleBannerDismiss} />
          </motion.div>
        )}
      </AnimatePresence>

      <motion.main
        className={style.main}
        id="main"
        initial={{ y: uiStore.showBanner ? bannerHeight : 0 }}
        animate={{ y: uiStore.showBanner ? bannerHeight : 0 }}
        transition={{ ...transitionDefaults, duration: 0.5 }}
      >
        <Header />

        <Navigation navigation={navigation} allResources={allResources} />

        {children}

        <Footer />
      </motion.main>
    </div>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

Layout.displayName = 'Layout'

export default observer(Layout)
